const GAMedias = [
  { name: 'wz', UA: 'UA-135174861-1' },
  { name: 'gk', UA: 'UA-174900451-1' }
]

export default {
  GA: (eType, ...prams) => {
    if (window.ga) {
      for (const media of GAMedias) {
        if (eType === 'create') {
          window.ga(eType, media.UA ? media.UA : prams[0], prams[1] || 'auto', media.name)
        } else {
          window.ga(`${media.name}.${eType}`, ...prams)
        }
      }
    }
  }
}
